// storage key

/** 用户ID */
import { debug } from '@/common/logger'
import Platform from '@/common/platform'
import { localStorage } from '@/utils/localStorage'

export const TOKEN = 'TOKEN'
/** 用户TOKEN */
export const USER_ID = 'USER_ID'

const win = window as any

export const getClientStorageForWebView = () => {
  try {
    const clientStorage = Platform?.getAllClientStorage()
    if (!clientStorage) return
    Object.keys(clientStorage || {})?.forEach((item: string) => {
      const value = clientStorage[item]
      if (typeof value !== 'undefined') {
        localStorage.setItem(item, value)
      }
    })
  } catch (e) {
    debug(e)
  }
}

/** 用户ID */
export const getUserId = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }
  return localStorage.getItem(USER_ID) ?? ''
}

export const removeUserId = (): void => {
  return localStorage.removeItem(USER_ID)
}

/** 用户TOKEN */
export const getUserToken = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  return localStorage.getItem(TOKEN) ?? ''
}

export const removeUserToken = (): void => {
  return localStorage.removeItem(TOKEN)
}

export const persistUserCredentials = (userId: string, token: string) => {
  localStorage.setItem(USER_ID, userId)
  localStorage.setItem(TOKEN, token)
}
